<template>
  <div class="white-container questions-page">
    <el-tabs v-model="activeName" :before-leave="beforeLeave">
      <el-tab-pane label="Lv1升2题目" name="two">
        <el-form ref="twoForm" :model="twoForm" :rules="rules" label-width="80px" size="small">
          <el-form-item label="下载模板" l>
            <div class="upload-wrapTop flex">
              <div class="tips">下载导入模板，根据模板完善内容</div>
              <div class="coupon_tip" @click="downTemplate">
                <i class="el-icon-document" />下载文件模板
              </div>
            </div>

          </el-form-item>
          <el-form-item label="上传文件" prop="excel">
            <div class="upload-wrap flex">
              <div class="tips">上传完善好的表格，仅支持上传*.xls、*.xlsx格式</div>
              <el-upload class="upload-box" drag action="" :show-file-list="false" :on-change="handleTwoUploader" :auto-upload="false">
                <div>
                  <div style="height: 50px">
                    <svg-icon icon-class="xls" style="width: 50px; height: 50px" />
                  </div>
                  <el-button v-if="!twoForm.excel" size="small">上传文件</el-button>
                  <template v-else>
                    <div class="file">{{ twoForm.excel.name }}</div>
                    <el-button size="small">重新选择</el-button>
                  </template>
                </div>
              </el-upload>
              <div class="history-box">
                <div class="title">最近上传记录</div>
                <table class="table-container">
                  <tr>
                    <th class="table-item">文件名</th>
                    <th class="table-item">上传者</th>
                    <th class="table-item">最近上传记录</th>
                    <th class="table-item">操作</th>
                  </tr>
                  <tr>
                    <template v-if="twoLast">
                      <td class="table-item">{{ twoLast.name }}</td>
                      <td class="table-item">{{ twoLast.uploaderName }}</td>
                      <td class="table-item">{{ twoLast.uploadTime }}</td>
                      <td class="table-item" @click="downTwoLast">下载</td>
                    </template>
                    <template v-else>
                      <td class="table-item">--</td>
                      <td class="table-item">--</td>
                      <td class="table-item">--</td>
                      <td class="table-item" />

                    </template>
                  </tr>
                </table>
              </div>
            </div>
          </el-form-item>
          <el-form-item style="width:100%; margin-top:50px;">
            <div class="flex btns">
              <el-button class="submit-btn" type="primary" @click="twoSubmit">确认</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="Lv4升5题目" name="five">
        <el-form ref="fiveForm" :model="fiveForm" :rules="rules" label-width="80px" size="small">
          <el-form-item label="下载模板" l>
            <div class="upload-wrapTop flex">
              <div class="tips">下载导入模板，根据模板完善内容</div>
              <div class="coupon_tip" @click="downTemplate">
                <i class="el-icon-document" />下载文件模板
              </div>
            </div>

          </el-form-item>
          <el-form-item label="上传文件" prop="excel">
            <div class="upload-wrap flex">
              <div class="tips">上传完善好的表格，仅支持上传*.xls、*.xlsx格式</div>
              <el-upload class="upload-box" drag action="" :show-file-list="false" :on-change="handleFiveUploader" :auto-upload="false">
                <div>
                  <div style="height: 50px">
                    <svg-icon icon-class="xls" style="width: 50px; height: 50px" />
                  </div>
                  <el-button v-if="!fiveForm.excel" size="small">上传文件</el-button>
                  <template v-else>
                    <div class="file">{{ fiveForm.excel.name }}</div>
                    <el-button size="small">重新选择</el-button>
                  </template>
                </div>
              </el-upload>
              <div class="history-box">
                <div class="title">最近上传记录</div>
                <table class="table-container">
                  <tr>
                    <th class="table-item">文件名</th>
                    <th class="table-item">上传者</th>
                    <th class="table-item">最近上传记录</th>
                    <th class="table-item">操作</th>
                  </tr>
                  <tr>
                    <template v-if="fiveLast">
                      <td class="table-item">{{ fiveLast.name }}</td>
                      <td class="table-item">{{ fiveLast.uploaderName }}</td>
                      <td class="table-item">{{ fiveLast.uploadTime }}</td>
                      <td class="table-item" @click="downFiveLast">下载</td>
                    </template>
                    <template v-else>
                      <td class="table-item">--</td>
                      <td class="table-item">--</td>
                      <td class="table-item">--</td>
                      <td class="table-item" />

                    </template>
                  </tr>
                </table>
              </div>
            </div>
          </el-form-item>
          <el-form-item style="width:100%; margin-top:50px;">
            <div class="flex btns">
              <el-button class="submit-btn" type="primary" @click="fiveSubmit">确认</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>
<script>
import { getFileType, imatateDownloadByA } from "@/common/js/util";
// 题库模板
const questionTemp = 'https://uaprd-1257321318.cos.ap-beijing.myqcloud.com/static/excel/%E7%9F%A5%E8%AF%86%E9%A2%98%E5%BA%93%E6%A8%A1%E6%9D%BF.xlsx';
export default {
  components: {},
  data() {
    return {
      activeName: "two", // two--Lv1升2题目,five--Lv4升5题目
      questionTemp,
      twoForm: {
        excel: null,
      },
      fiveForm: {
        excel: null,
      },
      twoLast: null,
      fiveLast: null,
      rules: {
        excel: [
          { required: true, message: '请上传文件', trigger: 'change' },
        ],
      },
    };
  },
  created() {
    this.beforeLeave('two');
  },
  methods: {
    beforeLeave(activeName, oldActiveName) {
      const typeObj = {
        "two": 0,
        "five": 1,
      };
      const lastObj = {
        "two": "twoLast",
        "five": "fiveLast",
      };
      this.$Api.questions.getQHistory(typeObj[activeName]).then(res => {
        if (res) {
          this[lastObj[activeName]] = res;
        } else {
          this[lastObj[activeName]] = null;
        }
      }).catch(() => {
        this[lastObj[activeName]] = null;
      }).finally(() => {
        return true;
      });
      return true;
    },
    downTemplate() {
      window.open(this.questionTemp);
    },
    handleTwoUploader(file) {
      if (getFileType(file.raw.name) !== "excel") {
        this.$message.error("导入失败，请选择Excel文件");
        return;
      }
      this.twoForm.excel = file.raw;
      this.$refs["twoForm"].validate();
      this.uploadFile(0);
    },
    /* type0--1升2,1--4升5*/
    uploadFile(type = 0) {
      const mapObj = {
        0: 'twoForm',
        1: 'fiveForm',
      };
      if (!this[mapObj[type]].excel) return;
      this.$Api.uploadFile.uploadExcel(this[mapObj[type]].excel, 'questions/detail/').then(res => {
        if (res) {
          this[mapObj[type]].url = res;
        }
      });
    },
    downTwoLast() {
      if (this.twoLast.url) {
        imatateDownloadByA(
          this.twoLast.url,
          this.twoLast.name
        );
      }
    },
    twoSubmit() {
      this.$refs["twoForm"].validate((valid) => {
        if (valid) {
          const formData = new FormData();
          formData.append('difficulty', 0);
          formData.append('excelName', this.twoForm.excel.name);
          formData.append('file', this.twoForm.excel);
          formData.append('url', this.twoForm.url);
          this.$Api.questions.putQuestions(formData).then(data => {
            this.$message.success('上传成功');
            this.beforeLeave('two');
          });
        } else {
          return false;
        }
      });
    },

    handleFiveUploader(file) {
      if (getFileType(file.raw.name) !== "excel") {
        this.$message.error("导入失败，请选择Excel文件");
        return;
      }
      this.fiveForm.excel = file.raw;
      this.$refs["fiveForm"].validate();
      this.uploadFile(1);
    },
    downFiveLast() {
      if (this.fiveLast.url) {
        imatateDownloadByA(
          this.fiveLast.url,
          this.fiveLast.name
        );
      }
    },
    fiveSubmit() {
      this.$refs["fiveForm"].validate((valid) => {
        console.log('valid', valid);
        if (valid) {
          const formData = new FormData();
          formData.append('difficulty', 1);
          formData.append('excelName', this.fiveForm.excel.name);
          formData.append('file', this.fiveForm.excel);
          formData.append('url', this.fiveForm.url);
          this.$Api.questions.putQuestions(formData).then(data => {
            this.$message.success('上传成功');
            this.beforeLeave('five');
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.questions-page {
  position: relative;
  .tips {
    font-family: "Noto Sans SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #494949;
    margin-bottom: 20px;
  }
  .upload-wrapTop {
    width: 100%;
    height: 114px;
    background: #f7f7f7;
    border: 1px dashed #bbbbbb;
    border-radius: 4px;
    padding: 20px 0;
    flex-direction: column;
    align-items: center;
    > .coupon_tip {
      cursor: pointer;
      user-select: none;
      width: 130px;
      height: 34px;
      background: #ffffff;
      border: 1px solid #bbbbbb;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      line-height: 20px;
      color: #000000;
      > i {
        margin-right: 7px;
      }
    }
    > .coupon_tip:hover {
      background: #f7f7f7;
      color: #afafaf;
    }
  }
  .upload-wrap {
    width: 100%;
    flex-direction: column;
    align-items: center;
    min-height: 434px;
    background: #f7f7f7;
    border: 1px dashed #bbbbbb;
    border-radius: 4px;
    padding: 20px 21px;
    .el-input__inner {
      height: 34px !important;
    }
    .el-upload-dragger {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .upload-box {
      width: 100%;
      height: 156px;

      :deep(.el-upload.el-upload--text) {
        width: 100%;
        height: 100%;
        .el-upload-dragger {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid #bbbbbb;
          border-radius: 4px;
          &:hover {
            border-color: #1c1c1c;
          }
          .file {
            line-height: 20px;
            margin-top: 5.68px;
          }
          .el-button {
            margin-top: 10px;
          }
        }
      }
    }
    .history-box {
      margin-top: 30px;
      width: 100%;
      .title {
        width: 100%;
        text-align: center;
        margin-bottom: 20px;
      }
      .table-container {
        border-collapse: collapse;
        width: 100%;
      }
      .table-item {
        text-align: left;
        background-color: #fff;
        white-space: nowrap;
      }
      .table-container tr:first-child .table-item {
        border-bottom: 1px solid #f7f7f7;
        padding: 15px 30px;
        width: 30%;
        &:last-child {
          width: 10%;
          text-align: right;
        }
      }
      .table-container tr:nth-child(2) .table-item {
        padding: 30px;
        &:last-child {
          text-align: right;
          color: #0085d0;
          cursor: pointer;
          user-select: none;
        }
      }

      .table-item:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }

      .table-item:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }
  .btns {
    align-items: center;
    justify-content: center;
    .submit-btn {
      width: 120px;
      height: 50px;
    }
  }
  .table-container {
    tr {
      &:last-of-type {
        td {
          color: #494949;
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>

